<router-outlet *ngIf="isAuthPage"></router-outlet>

<div class="app-shell" *ngIf="!isAuthPage">
  <aside class="sidebar" [class.open]="sidebarOpen">
    <div class="brand">
      <img class="brand-logo-mark" src="/img/brand/helipagos-iso-gradient.png" alt="Helipagos">
      <div>
        <strong>Helipagos</strong>
        <span>Payment Gateway</span>
      </div>
    </div>

    <nav class="nav-list">
      <ul class="nav-tree">
        <li><a routerLink="/dashboard" routerLinkActive="active"><span class="nav-icon">⌁</span>Panel de control</a></li>
        <li *ngFor="let item of auth.allowedNavigationItems">
          <ng-container *ngIf="item.children?.length; else simpleNavigation">
            <button class="nav-parent" type="button" [class.expanded]="isMenuExpanded(item.path)" (click)="toggleMenu(item.path)" [attr.aria-expanded]="isMenuExpanded(item.path)">
              <span class="nav-icon">{{ item.icon }}</span><span>{{ item.label }}</span><span class="nav-chevron">⌄</span>
            </button>
            <ul class="nav-children" *ngIf="isMenuExpanded(item.path)">
              <li *ngFor="let child of item.children">
                <ng-container *ngIf="child.children?.length; else simpleChild">
                  <button class="nav-parent nav-child-parent" type="button" [class.expanded]="isMenuExpanded(child.path)" (click)="toggleMenu(child.path)" [attr.aria-expanded]="isMenuExpanded(child.path)">
                    <span class="nav-icon">{{ child.icon }}</span><span>{{ child.label }}</span><span class="nav-chevron">⌄</span>
                  </button>
                  <ul class="nav-children nav-grandchildren" *ngIf="isMenuExpanded(child.path)">
                    <li *ngFor="let grandchild of child.children"><a class="nav-child nav-grandchild" [routerLink]="grandchild.path" routerLinkActive="active"><span class="nav-icon">{{ grandchild.icon }}</span>{{ grandchild.label }}</a></li>
                  </ul>
                </ng-container>
                <ng-template #simpleChild><a class="nav-child" [routerLink]="child.path" routerLinkActive="active"><span class="nav-icon">{{ child.icon }}</span>{{ child.label }}</a></ng-template>
              </li>
            </ul>
          </ng-container>
          <ng-template #simpleNavigation><a [routerLink]="item.path" routerLinkActive="active"><span class="nav-icon">{{ item.icon }}</span>{{ item.label }}</a></ng-template>
        </li>
      </ul>
    </nav>

    <button class="logout-button" type="button" (click)="logout()" *ngIf="auth.isAuthenticated">Cerrar sesión</button>
  </aside>

  <div class="content-shell">
    <header class="topbar">
      <button class="icon-button mobile-only" type="button" (click)="toggleSidebar()" aria-label="Menu">
        ☰
      </button>
      <div>
        <span class="eyebrow">Helipagos</span>
        <h1>Gateway operativo</h1>
      </div>
      <div class="user-pill">
        <span class="status-dot"></span>
        Vista UI
      </div>
    </header>

    <main>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
